import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import DefaultLayoutHOC from '../layoutHOC/defaultLayout';
import ProfileReadOnly from './detailsReadOnly';
import Config from '../../config/Config';
import Loader from '../../utils/Loader';
import Details from './details';
import {
	getProfileDetails,
	toggleEdit,
} from '../../redux/profile/profile.actions';
import ProfileTabLinks from '../common/profileTabLinks';
import ErrorToast from '../common/errorToast';
import { setErrorPanel } from '../../redux/utilities/utils.actions';
import { resetToken } from '../../redux/parentDashboard/parentDashboard.actions';
import UserTypes from '../../utils/userTypes';
import ListAnimation from '../utils/animations/list';
import { getParameterByName } from '../../utils/commonFunctions';
const Profile = ({
	Msg,
	getProfileDetails,
	editProfile,
	toggleEdit,
	setErrorPanel,
	resetToken,
	userType,
}) => {
	useEffect(() => {
		if (userType === UserTypes.Parent) {
			resetToken();
		}
	}, [userType, resetToken]);

	useEffect(() => {
		getProfileDetails();
		setTimeout(() => {
			Loader.hide();
			const header = document.getElementById('profileHeader');
			if (!!header) {
				header.classList.add('profilepageheader');
			}
		}, 1000);

		return () => {
			document
				.getElementById('profileHeader')
				.classList.remove('profilepageheader');
		};
	}, [getProfileDetails]);

	useEffect(() => {
		return () => {
			setErrorPanel({});
		};
	}, [setErrorPanel]);

	let eMessage = "";

	if (getParameterByName('boa') === '1') {
		eMessage = "Click edit & update your name, email & phone number";
	}

	return (
		<>
			<link
				href={Config.ASSETSPATH + 'css/react-datepicker.css'}
				rel="stylesheet"
			/>

			<div className="settingsContainer">
				{!!eMessage ? (
					<div className="update_popup_error">Click edit & update your name, email & phone number</div>
				) : null}
				<div className="message_box">{Msg}</div>
				{window.outerWidth > 768 ? (
					<ProfileTabLinks />
				) : (
					<h4 className="section-body-title">Personal Information </h4>
				)}
				<ListAnimation open={true} className="profile_page_accordion ">
					{editProfile ? <Details /> : <ProfileReadOnly />}
				</ListAnimation>
			</div>

			<ErrorToast />
		</>
	);
};

const mapStateToProps = (state) => {
	const { editProfile } = state.rootReducer.profileDetails;
	const { userType } = state.rootReducer.loginDetails;
	return {
		editProfile,
		userType,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getProfileDetails: () => dispatch(getProfileDetails()),
		toggleEdit: () => dispatch(toggleEdit()),
		resetToken: () => dispatch(resetToken()),
		setErrorPanel: (msg) => dispatch(setErrorPanel(msg)),
	};
};

export default withRouter(
	compose(
		connect(mapStateToProps, mapDispatchToProps),
		DefaultLayoutHOC,
	)(Profile),
);
